import { Link } from "react-router-dom";
import { DoubleRightOutlined } from "@ant-design/icons";
import DashboardEorder from "../../components/Dashboard/DashboardEorder";
import Dashboardfifth from "../../components/Dashboard/DashboardFifth";
import Dashboardfourth from "../../components/Dashboard/Dashboardfourth";
import EOrderDash from "../../components/Dashboard/EOrderDash";
import HomeDash from "../../components/Dashboard/HomeDash";
import DashboardAmount from "../../components/Dashboard/dashboardAmount";
import Dashboardthird from "../../components/Dashboard/dashboardthird";
import Navbar from "../../components/Navbar/Navbar";
import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../components/Loading";
import ShimmerLoader, { DashboardShimmer } from "../../loading";
import { Breadcrumb } from "antd";
import { routes } from "../../Routes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PurchaseDash from "../../components/Dashboard/PurchaseDash";
import { URLS } from "../../API/API endpoints";
import axios from "axios";
import { getUserOnboarding } from "../../API  Functions/DashboardFunctions";
import IsAddProd from "../../assets/Dashboard/IsAddProd.svg";
import IsMachineCode from "../../assets/Dashboard/IsMachineCode.svg";
import IsCashierSetup from "../../assets/Dashboard/IsCashierSetup.svg";
import IsAddUser from "../../assets/Dashboard/IsAddUser.svg";
import { BarChart, barElementClasses } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import { PieChart } from "@mui/x-charts/PieChart";
import axiosInstance from "../../AxiosInstance";
import averageordervalue from "../../assets/Dashboard/averageordervalue.svg";
import creditvalue from "../../assets/Dashboard/creditvalue.svg";
import totalorder from "../../assets/Dashboard/totalorder.svg";
import totalsales from "../../assets/Dashboard/totalsales.svg";
import { DatePicker, Space } from "antd";
import SelectBox from "../../components/CustomWidgets/SelectBox";
import dayjs from "dayjs";
import moment from "moment";
import DateFilter from "../../components/ui/DateFilter";
import { Typography } from "@mui/material";



const OnlinePosDashboard = ({ start, end, refreshKey }) => {
  const { t, i18n } = useTranslation();
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const is_retailer = useSelector(
    (state) => state?.login?.user?.result?.is_retailer
  );

  const [loading, setLoading] = useState(false);
  const [dashbaordData, setDashbaordData] = useState({});

  useEffect(() => {
    GetdashboardData();
  }, [start, end, refreshKey, company_id]);

  const GetdashboardData = async () => {
    let payload = {
      company_id: company_id,
      lang: i18n.language == "ar" ? "ar_001" : "en_US",
      start_date: start,
      end_date: end,
    };
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        URLS.DASHBOARD_SUMMARY,
        payload
      );
      // console.log("DATA===>", response?.data);

      if (response?.data?.result) {
        setDashbaordData(response?.data?.result);
      } else {
        setDashbaordData({});
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const chartSetting = {
    yAxis: [
      {
        label: `${t("Sales Value (EGP)")}`,
        labelStyle: {
          fontFamily: 'Cairo, sans-serif',
          fontWeight: 600, // optional
        },
      },
    ],
    width: 570,
    height: 300,
    barLabel: "value",
    margin: { left: 80, right: 110 }, // 👈 add space on the left
    borderRadius: 10,
    sx: {
      "& .MuiBarLabel-root": {
        fill: "#fff", // 👈 white label text
        fontWeight: 600, // optional
        fontSize: 12, // optional
      },
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: "translate(-40px, 0)",
      },
    },
  };

  const dataset = Object.entries(dashbaordData?.monthly_sales ?? {}).map(
    ([month, values]) => ({
      month: t(month), // e.g. "July"
      online_sales: values.online,
      pos_sales: values.pos,
    })
  );
  // const dataset =[]

  const statusColors = {
    "In Processing": "#FFC107",
    "Order Completed": "#20C997",
    "Ready For Delivery": "#266EA8",
    "On the way": "#2F80ED",
    "Order Delivered": "#27AE60",
    "Order Pending": "#FFEB3B",
    cancel: "#EB5757",
  };
  const statusLabel = {
    "Order Pending": `${t("order_pending")}`,
    "In Processing": `${t("In Processing")}`,
    "Ready For Delivery": `${t("ready_for_delivery")}`,
    "On the way": `${t("Out For Delivery")}`,
    "Order Delivered": `${t("Order Delivered")}`,
    "Order Completed": `${t("Order Completed")}`,
    cancel: `${t("Order Cancelled")}`,
  };

  // Convert object → array for PieChart
  const excludedKeys = [
    "paid",
    "done",
    "Order Arrived",
    "Order Pickup",
    "Draft",
  ];

  const filteredEntries = Object.entries(
    dashbaordData?.order_status_breakdown ?? {}
  ).filter(([label]) => !excludedKeys.includes(label));

  // calculate total
  const total = filteredEntries.reduce((acc, [, value]) => acc + value, 0);

  const pieData = (() => {
    const allZero = filteredEntries.every(([_, value]) => value === 0);
    if (allZero) return [];

    return filteredEntries.map(([label, value], index) => {
      const percentage = ((value / total) * 100).toFixed(1); // keep 1 decimal
      return {
        id: index,
        value,
        label: statusLabel[label],
        percentage,
        color: statusColors[label] || "#ccc",
      };
    });
  })();

  const orderPaymentPieData = (() => {
    const data = [
      {
        id: 0,
        value: dashbaordData?.payment_method_split?.cod?.percentage ?? 0,
        val: dashbaordData?.payment_method_split?.cod?.orders ?? 0,
        label: t("COD"),
        color: "#2F80ED",
      },
      {
        id: 1,
        value: dashbaordData?.payment_method_split?.bank?.percentage ?? 0,
        val: dashbaordData?.payment_method_split?.bank?.orders ?? 0,
        label: t("Bank"),
        color: "#F2994A",
      },
    ];

    return data.every((item) => item.value === 0) ? [] : data;
  })();

  const filteredStatus = Object.entries(
    dashbaordData?.order_status_breakdown ?? {}
  ).filter(([key]) => key !== "paid" && key !== "done");
  
const formatAmount = (value) => {
  const num = Number(value) || 0;

  if (Math.abs(num) >= 1_000_000) {
    return `${Math.floor((num / 1_000_000) * 10) / 10}M`;
  }

  if (Math.abs(num) >= 1_000) {
    return `${Math.floor((num / 1_000) * 10) / 10}K`;
  }

  return num.toFixed(2);
};

  const values = [
{
  img: totalsales,
  heading: t("Total Sales"),
  productsleft: formatAmount(dashbaordData?.total_sales),
  fullValue: `${t("EGP")} ${dashbaordData?.total_sales?.toFixed(2) || "0"}`,
  bgcolor: "#2F80ED29",
  textcolor: "#2F80ED",
},
{
      img: totalorder,
      heading: t("Total Orders"),
      productsleft: dashbaordData?.total_orders || "0",
      bgcolor: "#DBFBDA6B",
      textcolor: "#059003",
    },
{
  img: averageordervalue,
  heading: t("Average Order Value"),
  productsleft: formatAmount(dashbaordData?.average_order_value),
  fullValue: `${t("EGP")} ${dashbaordData?.average_order_value?.toFixed(2) || "0"}`,
  bgcolor: "#FFE5CD85",
  textcolor: "#EB853C",
},
{
  img: creditvalue,
  heading: t("Pending COD Value"),
  productsleft: formatAmount(dashbaordData?.pending_cod_value),
  fullValue: `${t("EGP")} ${dashbaordData?.pending_cod_value?.toFixed(2) || "0"}`,
  bgcolor: "#EB575729",
  textcolor: "#EB5757",
},
 
  ];

  const valueFormatter = (item) =>
    `${item?.percentage ? item?.percentage : "0"}% (${item?.value ? item?.value : "0"
    })`;
  const valueFormatterMethod = (item) =>
    `${item?.value ? item?.value : "0"}% (${item?.val ? item?.val : "0"})`;

  return (
    <>
      {/* {loading && <LoadingSpinner />} */}
      <div className="scrollbar-hide flex w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-4 md:h-full">
        <div className="custom-scrollbar ms-0 flex-grow overflow-y-auto overflow-hidden sm:ms-3">
          {loading ? (
            <div className=" mt-3 me-4 w-full">
              <DashboardShimmer />
            </div>
          ) : (
            <>
              <div className="me-0 mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 md:me-4">
                {Object.values(values).map((val, index) => (
                  <div
                    key={index}
                    className={`rounded-xl px-5 py-4 shadow-sm transition-transform transform ${val.wide ? "col-span-2" : ""
                      }`}
                    style={{ backgroundColor: val.bgcolor }}
                    onClick={val.action}
                  >
                    <div className="flex items-center justify-between gap-3">
                      <div className="flex items-center gap-3">
                        <img src={val.img} alt="icon" className="w-10 h-10" />
                        <div className="flex flex-col">
                          <p className="text-sm font-medium text-gray-700 truncate">
                            {val.heading}
                          </p>

                         <p
  className="text-xl font-bold"
  style={{ color: val.textcolor }}
  title={val.fullValue}   // hover tooltip
>
  {val.fullValue ? `${t("EGP")} ${val.productsleft}` : val.productsleft}
</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div
                dir="ltr"
                className={`mt-4 flex flex-col md:flex-row justify-between gap-4 ${i18n.language == "ar" ? "ps-0 md:ps-4" : "pe-0 md:pe-4"}`}
              >
                <div className="w-full rounded-2xl border border-[#EDEEF1] bg-white px-3 py-4 sm:px-5 md:w-7/12">
                  <h3 className="font-bold mt-2">
                    {t("Monthly Sales by Channel (3 Months)")}
                  </h3>
                  {dataset?.length > 0 ? (
                    <>
                      <div className="overflow-x-auto">
                        <div className="min-w-[660px]">
                          <BarChart
                            dataset={dataset}
                            xAxis={[{ scaleType: "band", dataKey: "month" }]}
                            series={[
                              {
                                dataKey: "online_sales",
                                label: t("Online Sales"),
                                color: "#2F80ED",
                              },
                              {
                                dataKey: "pos_sales",
                                label: t("Cashier Sales"),
                                color: "#F2994A",
                              },
                            ]}
                            slotProps={{
                              legend: {
                                direction: "column", // row | column
                                position: { vertical: "top", horizontal: "right" }, // top, bottom, left, right
                                padding: 0,
                                itemMarkWidth: 25, // size of color box
                                itemMarkHeight: 15,
                                labelStyle: {
                                  fontFamily: "Cairo, sans-serif", // ✅ legend labels
                                  marginLeft: 5,
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: "#333",
                                },
                              },
                            }}
                            {...chartSetting}
                          />
                        </div>
                      </div>
                      <p
                        style={{ fontWeight: 600 }}
                        className="ms-2 mt-2 text-sm font-medium text-[#111111] sm:ms-6 md:ms-60 md:-mt-4"
                      >
                        {t("Month")}
                      </p>
                    </>
                  ) : (
                    <>
                      <div className=" text-sm flex justify-center h-full items-center">
                        <p>{t("No data available")}</p>
                      </div>
                    </>
                  )}
                </div>
                <div className="flex w-full flex-col justify-between rounded-2xl border border-[#EDEEF1] bg-white px-3 py-4 sm:px-5 md:w-5/12">
                  <h3 className="font-bold mb-4  mt-2">{t("Order Status")}</h3>
                  {pieData?.length > 0 ? (
                    <>
                      <div className="overflow-x-auto">
                        <div className="min-w-[420px]">
                          <PieChart
                            series={[
                              {
                                data: pieData,
                                arcLabel: (params) => `${params.percentage}%`, // show percentage
                                innerRadius: 50,
                                valueFormatter,
                              },
                            ]}
                            width={430}
                            height={190}
                            margin={{ left: -50 }}
                            slotProps={{
                              legend: {
                                direction: "column",
                                position: { vertical: "top", horizontal: "right" },
                                padding: 8,
                                itemMarkWidth: 25,
                                itemMarkHeight: 15,
                                labelStyle: {
                                  fontFamily: "Cairo, sans-serif",
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: "#333",
                                },
                              },
                              pieArcLabel: {
                                style: {
                                  fontFamily: "Cairo, sans-serif",
                                  fontSize: 12, // 👈 reduce arc label font size
                                  fontWeight: 600,
                                  fill: "#fff",
                                },
                              },
                            }}
                            sx={{
                              "& .MuiChartsArcLabel-root": {
                                fontSize: 10, // 👈 reduce font size here
                                fontWeight: 600,
                                fill: "#fff", // optional: white text for better contrast
                              },
                            }}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className=" text-sm flex justify-center h-full items-center">
                        <p>{t("No data available")}</p>
                      </div>
                    </>
                  )}

                </div>
              </div>
              <div
                dir="ltr"
                className={`mt-4 flex flex-col md:flex-row justify-between gap-4 ${i18n.language == "ar" ? "ps-0 md:ps-4" : "pe-0 md:pe-4"}`}
              >
                <div className="flex min-h-[320px] w-full flex-col justify-between rounded-2xl border border-[#EDEEF1] bg-white px-3 py-4 sm:px-5 md:w-5/12">
                  <h3 className="font-bold mb-4  mt-2">
                    {t("Payment Method Split (Online)")}
                  </h3>
                  {orderPaymentPieData?.length > 0 ?
                    <div className="overflow-x-auto">
                      <div className="min-w-[400px]">
                        <PieChart
                          series={[
                            {
                              data: orderPaymentPieData,
                              arcLabel: (params) => `${params?.value}%` ?? "",
                              innerRadius: 50,
                              valueFormatter: valueFormatterMethod,
                            },
                          ]}
                          width={400}
                          height={190}
                          margin={{
                            left: -30,
                          }}
                          slotProps={{
                            legend: {
                              direction: "column",
                              position: { vertical: "top", horizontal: "right" },
                              padding: 8,
                              itemMarkWidth: 25,
                              itemMarkHeight: 15,
                              labelStyle: {
                                fontFamily: "Cairo, sans-serif",
                                fontSize: 14,
                                fontWeight: 500,
                                color: "#333",
                              },
                            },
                            pieArcLabel: {
                              style: {
                                fontSize: 12,
                                fontWeight: 600,
                                fill: "#fff",
                              },
                            },
                          }}
                          sx={{
                            "& .MuiChartsArcLabel-root": {
                              fontSize: 12,
                              fontWeight: 600,
                              fill: "#fff", // white for better contrast
                            },
                          }}
                        />
                      </div>
                    </div>
                    :
                    <div className=" text-sm flex justify-center h-full items-center">
                      <p>{t("No data available")}</p>
                    </div>}
                </div>
                {/* <div className="flex justify-between w-7/12 gap-3">
                  <div className=" flex flex-col rounded-2xl bg-[#FFFFFF99] px-5 py-4  w-1/2 justify-between ">
                    <h3 className="font-bold mb-2  mt-2">
                      {t("Order Status Details")}
                    </h3>
                    <div className="flex flex-row justify-between px-2">
                      <p className="font-normal text-[#93989C] text-sm">
                        {t("Status")}
                      </p>
                      <p className="font-normal text-[#93989C] text-sm">
                        {t("Orders")}
                      </p>
                    </div>
                    {dashbaordData?.order_status_breakdown && (
                      <>
                        {filteredEntries?.map(([status, value], idx) => (
                          <div
                            key={idx}
                            className={`flex flex-row justify-between border-[#F0F0F0] py-1 rounded-lg px-2 ${
                              status === "Order Delivered" ? "bg-[#FFF7DF]" : ""
                            }`}
                          >
                            <p className="font-medium text-[#111111] text-sm">
                              {t(statusLabel[status])}
                            </p>
                            <p className="font-semibold text-sm text-start w-10">
                              {value}
                            </p>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                  <div className=" flex flex-col rounded-2xl bg-[#FFFFFF99] px-5 py-4  w-1/2">
                    <h3 className="font-bold mb-2  mt-2">
                      {t("Order Status Details")}
                    </h3>
                    <div className="flex flex-row justify-between mt-2 mb-3">
                      <p className="font-normal text-[#93989C] text-sm">
                        {t("Method")}
                      </p>
                      <p className="font-normal text-[#93989C] text-sm">
                        {t("Orders")}
                      </p>
                    </div>
                    <div className="flex flex-row justify-between mb-3 bg-[#FFF7DF] py-1 rounded-lg px-2">
                      <p className="font-medium text-[#111111] text-sm">
                        {t("COD")}
                      </p>
                      <p className="font-semibold text-sm text-start w-10">
                        {dashbaordData?.payment_method_split?.cod?.orders}
                      </p>
                    </div>
                    <div className="flex flex-row justify-between  mb-3 bg-[#FFF7DF] py-1 rounded-lg px-2">
                      <p className="font-medium text-[#111111] text-sm">
                        {t("Bank")}
                      </p>
                      <p className="font-semibold text-sm text-start w-10">
                        {dashbaordData?.payment_method_split?.bank?.orders}
                      </p>
                    </div>
                  </div>
                </div> */}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default OnlinePosDashboard;
